import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import { BodyNormal, LinkWithIcon, RunsOnAtlassianIcon } from '@atlassian/mpac-primitives';
import { ExternalLinks } from '@atlassian/mpac-types';
import queryString from 'query-string';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { ContentHeader, ContentItems, ContentWrapper, Heading, Label } from './Certification.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const RunsOnAtlassianContent = () => {
  const faqPageLink = queryString.stringifyUrl({
    url: ExternalLinks.cloudFortified.faq,
    query: {
      source: 'app-listing-privacy-and-security'
    }
  });
  const {
    fireViewDetailsEvent
  } = usePrivacyAndSecurityAnalytics();
  const onMoreDetailsClicked = () => {
    fireViewDetailsEvent('Atlassian trust programs - Runs on Atlassian - more details');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ContentHeader, {
      children: [/*#__PURE__*/_jsx(RunsOnAtlassianIcon, {
        customSize: "32",
        label: ""
      }), /*#__PURE__*/_jsx(Heading, {
        children: "RUNS ON ATLASSIAN"
      })]
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(BodyNormal, {
        children: "This app runs on Atlassian infrastructure to meet enterprise needs."
      }), /*#__PURE__*/_jsxs(ContentItems, {
        children: [/*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx(CheckMarkIcon, {
            label: ""
          }), /*#__PURE__*/_jsx(Label, {
            children: "Hosted on Atlassian"
          })]
        }), /*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx(CheckMarkIcon, {
            label: ""
          }), /*#__PURE__*/_jsx(Label, {
            children: "Data stored within Atlassian"
          })]
        }), /*#__PURE__*/_jsxs(ContentHeader, {
          children: [/*#__PURE__*/_jsx(CheckMarkIcon, {
            label: ""
          }), /*#__PURE__*/_jsx(Label, {
            children: "Data residency compliant"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(LinkWithIcon, {
      type: "external",
      size: "medium",
      href: faqPageLink,
      onClick: onMoreDetailsClicked,
      children: "More details"
    })]
  });
};